import Cookies from 'js-cookie';

import { SPLIT_TEST_NAME } from './SPLIT_TESTS';
import { STEP_0_ELIGIBILITY_PREVIEW_COOKIE } from './step0PreviewCookie';
import { useAnonymousSplitTests } from './useAnonymousSplitTests';

export function useIsInStep0EligibilityTest(): boolean {
  const isPreviewEnabled =
    Cookies.get(STEP_0_ELIGIBILITY_PREVIEW_COOKIE) === 'true';

  const splitTests = useAnonymousSplitTests({
    testFilter: SPLIT_TEST_NAME.NEW_CUSTOMERS_STEP_0_ELIGIBILITY_2026,
    // Launch gate. Swap for useLocale's isUK to start enrolling — UK only.
    enabled: false,
  });

  return isPreviewEnabled || splitTests?.[0]?.branch_name === 'INCLUDE';
}
